import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd86d4e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "accept", "onChange"]
const _hoisted_3 = {
  key: 1,
  class: "selected-file-info mt-2"
}
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}, null, -1))
const _hoisted_6 = { class: "text-muted" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = {
  key: 2,
  class: "form-help"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dp_field = _resolveComponent("dp-field")!
  const _component_dp_error_message = _resolveComponent("dp-error-message")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dp-input mb-3", {
        'has-error': _ctx.errors[_ctx.name],
      }])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.name,
          class: "form-label"
        }, _toDisplayString(_ctx.label), 9, _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_component_dp_field, {
      name: _ctx.name,
      rules: _ctx.rules,
      modelValue: _ctx.modelValue,
      "onUpdate:modelValue": _ctx.updateValue
    }, {
      default: _withCtx(({ setFieldError }) => [
        _createElementVNode("input", _mergeProps({
          ref: "fileInput",
          class: ["form-control", {
          'is-invalid': _ctx.errors[_ctx.name],
        }],
          type: "file",
          id: _ctx.name,
          accept: _ctx.acceptAttribute,
          onChange: (event) => _ctx.handleFileSelection(event, setFieldError)
        }, _ctx.$attrs), null, 16, _hoisted_2)
      ]),
      _: 1
    }, 8, ["name", "rules", "modelValue", "onUpdate:modelValue"]),
    (_ctx.selectedFile || _ctx.isUploading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.isUploading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("small", _hoisted_6, _toDisplayString(_ctx.$t('uploading')) + "...", 1)
              ]))
            : (_ctx.selectedFile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("small", _hoisted_8, _toDisplayString(_ctx.$t('selectedFile')) + ": " + _toDisplayString(_ctx.selectedFile.name) + " (" + _toDisplayString(_ctx.formatFileSize(_ctx.selectedFile.size)) + ") ", 1),
                  (_ctx.canBeCleared)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearSelection && _ctx.clearSelection(...args))),
                        class: "btn btn-sm btn-outline-danger ms-2",
                        type: "button"
                      }, _toDisplayString(_ctx.$t('delete')), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_dp_error_message, {
      class: "invalid-feedback d-block",
      name: _ctx.name
    }, null, 8, ["name"]),
    (_ctx.help)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.help), 1))
      : _createCommentVNode("", true)
  ], 2))
}